'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, Suspense, useContext, createContext } from 'react';
import FavoritesModal from '@/app/_components/FavoritesModal';
import CartModal from '@/app/_components/CartModal';
import SignInModal from '@/app/_components/SignInModal';
import NewsletterSignupModal from '@/app/_components/NewsletterSignupModal';
import SideTabs from '@/app/_components/SideTabs';
import { HelpWidgetProvider } from '@/app/_plugins/HelpWidget';
import { ConfirmDialogProvider } from '@/app/_lib/_context/ConfirmDialogContext';
import { useErrorReporting, useSideTabs } from '@/app/_lib/hooks';
const AppContext = createContext({});
export const AppWrapper = t0 => {
  const $ = _c(40);
  const {
    children
  } = t0;
  const [, setBodyClass] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [activeCategoryTree, setActiveCategoryTree] = useState(t1);
  const [favoritesModalOpen, setFavoritesModalOpen] = useState(false);
  const [favoritesModalData, setFavoritesModalData] = useState(false);
  const [cartModalOpen, setCartModalOpen] = useState(false);
  const [cartModalContent, setCartModalContent] = useState(false);
  const [signInModalOpen, setSignInModalOpen] = useState(false);
  const [activeSearch, setActiveSearch] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useErrorReporting();
  const sideTabs = useSideTabs();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = modalContent => {
      if (modalContent) {
        setCartModalContent(modalContent);
      }
      setCartModalOpen(true);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const openCartModal = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setCartModalOpen(false);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const closeCartModal = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setSignInModalOpen(true);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const openSignInModal = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setSignInModalOpen(false);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const closeSignInModal = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = data => {
      setFavoritesModalData(data);
      setFavoritesModalOpen(true);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const openFavoritesModal = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setFavoritesModalOpen(false);
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const closeFavoritesModal = t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setActiveSearch(true);
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const openSearch = t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setActiveSearch(false);
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const closeSearch = t9;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setMobileMenuOpen(true);
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const openMobileMenu = t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setMobileMenuOpen(false);
    };
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const closeMobileMenu = t11;
  let t12;
  if ($[11] !== activeCategoryTree || $[12] !== activeSearch || $[13] !== favoritesModalOpen || $[14] !== mobileMenuOpen || $[15] !== sideTabs) {
    t12 = {
      setBodyClass,
      favoritesModalOpen,
      setFavoritesModalOpen,
      openFavoritesModal,
      openCartModal,
      closeCartModal,
      setCartModalContent,
      activeSearch,
      openSearch,
      closeSearch,
      mobileMenuOpen,
      openMobileMenu,
      closeMobileMenu,
      activeCategoryTree,
      setActiveCategoryTree,
      openSignInModal,
      closeSignInModal,
      ...sideTabs
    };
    $[11] = activeCategoryTree;
    $[12] = activeSearch;
    $[13] = favoritesModalOpen;
    $[14] = mobileMenuOpen;
    $[15] = sideTabs;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== favoritesModalData || $[18] !== favoritesModalOpen) {
    t13 = <Suspense><FavoritesModal isOpen={favoritesModalOpen} setIsOpen={closeFavoritesModal} modalData={favoritesModalData} contentLabel="Manage Favorites" /></Suspense>;
    $[17] = favoritesModalData;
    $[18] = favoritesModalOpen;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== cartModalContent || $[21] !== cartModalOpen) {
    t14 = <CartModal isOpen={cartModalOpen} setIsOpen={closeCartModal} contentLabel="hive Shopping Cart" modalContent={cartModalContent} />;
    $[20] = cartModalContent;
    $[21] = cartModalOpen;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== signInModalOpen) {
    t15 = <SignInModal isOpen={signInModalOpen} onClose={closeSignInModal} onSuccess={closeSignInModal} />;
    $[23] = signInModalOpen;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== sideTabs.completePromoSignup || $[26] !== sideTabs.hidePromoModal || $[27] !== sideTabs.refusePromoModal || $[28] !== sideTabs.shouldShowPromoModal) {
    t16 = <NewsletterSignupModal isOpen={sideTabs.shouldShowPromoModal} onBackgroundClick={sideTabs.hidePromoModal} onRefuse={sideTabs.refusePromoModal} onSignupComplete={sideTabs.completePromoSignup} contentLabel="Sign Up" />;
    $[25] = sideTabs.completePromoSignup;
    $[26] = sideTabs.hidePromoModal;
    $[27] = sideTabs.refusePromoModal;
    $[28] = sideTabs.shouldShowPromoModal;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SideTabs />;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== children || $[32] !== t13 || $[33] !== t14 || $[34] !== t15 || $[35] !== t16) {
    t18 = <ConfirmDialogProvider><HelpWidgetProvider>{children}{t13}{t14}{t15}{t16}{t17}</HelpWidgetProvider></ConfirmDialogProvider>;
    $[31] = children;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t12 || $[38] !== t18) {
    t19 = <AppContext.Provider value={t12}>{t18}</AppContext.Provider>;
    $[37] = t12;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
};
export const useAppContext = () => {
  return useContext(AppContext);
};

// Re-export confirm dialog hook for convenient access
export { useConfirmDialog } from '@/app/_lib/_context/ConfirmDialogContext';